const customerTaxCodeTypes = {
  pccc: 'pccc',
  cpfCnpj: 'cpf_cnpj',
  residentId: 'resident_id',
  cf: 'cf',
  pec: 'pec',
  rfc: 'rfc',
  nif: 'nif',
}

export const customerTaxCodeLabels = {
  [customerTaxCodeTypes.pccc]: 'Código personal de aduanas (PCCC)',
  [customerTaxCodeTypes.cpfCnpj]: 'CPF / CNPJ',
  [customerTaxCodeTypes.residentId]: 'Documento de identidad de residente (China)',
  [customerTaxCodeTypes.cf]: 'Código fiscal (CF)',
  [customerTaxCodeTypes.pec]: 'Correo electrónico certificado (PEC)',
  [customerTaxCodeTypes.rfc]: 'RFC (Registro Federal de Contribuyentes)',
  [customerTaxCodeTypes.nif]: 'NIF / DNI',
}
